export default "__VITE_ASSET__bfce59ec__"